import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkHeading } from "uitk-react-text";
import { UitkCarousel } from "uitk-react-carousel";
import { AnalyticsConfig } from "uitk-react-utils";

import { ProductTypeContext } from "components/flexComponents/TopCities/TopCities";
import { cityCard, topLevelComponentClassName, carouselItemsVisible } from "./topCitiesDestinationUtils";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";

import { TopCitiesDestinationProps } from "components/flexComponents/TopCities/typings";
import { CityCardDestination } from "typings/microserviceModels/top-cities-flex-module";
import { withStores } from "stores";

const TopCitiesDestination = withStores("analytics")((props: TopCitiesDestinationProps) => {
  const { flexComponent, context } = props;
  const { id, model } = flexComponent;
  const { view, title, topCities, productType } = model;
  const { formatText } = useLocalization();
  const cityCardKeyHelper = new ItemKeyHelper("topCitiesCard");

  const carouselAnalytics: AnalyticsConfig = {
    id: `LP.TopCities.${productType}`,
    callback: (theId, description) => {
      const flexTrackingInfo: FlexTrackingInfo = {
        moduleName: theId,
        action: Action.SCROLL,
        linkName: description,
      };
      sendDelayedTrackEvent(flexTrackingInfo, props.analytics);
    },
  };

  const CityCard = cityCard[view];

  return (
    <ProductTypeContext.Provider value={productType.toLowerCase()}>
      <div id={id} className={topLevelComponentClassName[view]}>
        <UitkHeading level={2} size={600}>
          {title || formatText("topCities.title", context.searchContext.location.localizedName)}
        </UitkHeading>

        <UitkCarousel
          analytics={carouselAnalytics}
          buttonText={{
            nextButton: formatText("carousel.item.next"),
            prevButton: formatText("carousel.item.prev"),
          }}
          carouselName="topCitiesCarousel"
          className="all-t-margin-three"
          itemsVisible={carouselItemsVisible[view]}
          pageBy={1}
          peekWidth={12}
        >
          {topCities.map((city: CityCardDestination) => (
            <CityCard key={cityCardKeyHelper.next()} city={city} />
          ))}
        </UitkCarousel>
      </div>
    </ProductTypeContext.Provider>
  );
});

export default TopCitiesDestination;
